/**
 * „Now" for the booking tabs, moved once a minute: the countdown, the running ring, the agenda's now
 * rule, the notice's nearest start — every one of them is a minute.
 */

import { useEffect, useState } from 'react';

const TICK_MS = 60_000;

export function useMinuteClock(): number {
  const [nowMs, setNowMs] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => {
      setNowMs(Date.now());
    }, TICK_MS);
    return () => {
      window.clearInterval(id);
    };
  }, []);
  return nowMs;
}
